<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for -->
  <div>
    <div id="khi_single" class="uk-container">
      <router-link :to="{ name: 'Kursliste' }" class="backlink">
        &lt;&lt; Zurück zur Übersicht
      </router-link>
      <div class="uk-grid">
        <div class="titel uk-width-1-1">
          <h1>{{ showkurs.sembezall }}</h1>
        </div>
        <div class="innerwrap uk-width-3-4@m @uk-width-1-1@s">
          <div class="categories">
            <div v-for="(categ, index) of showkurs.categs" :key="index" class="singlecat">
              {{ categ.title }}
            </div>
          </div>
          <div class="content">
            <span v-html="showkurs.content" />
          </div>
        </div>
        <aside class="uk-width-1-4@m @uk-width-1-1@s">
          <div class="kursdetails">
            <div class="shadowwrap">
              <div class="sidebar_title kursid">Kurs-Nr.:{{ showkurs.interneid }}</div>
              <div class="innerwrap">
                <div class="titel">
                  {{ showkurs.titel }}
                </div>
                <div
                  v-for="(termin, index) of showkurs.termins"
                  :key="index"
                  class="zeitwrapper has_icon"
                >
                  <span class="icon_infront" uk-icon="clock" />
                  <span class="date">{{ getDateString(termin.datum) }}</span>
                  <div class="start">
                    <span class="time">von: {{ termin.terminstart }} Uhr</span>
                  </div>
                  <div class="end">
                    <span class="time">bis: {{ termin.terminende }} Uhr</span>
                  </div>
                </div>
                <div v-if="showkurs.voadresse" class="ort has_icon">
                  <span class="icon_infront" uk-icon="location" />
                  <div>{{ showkurs.voadresse }}</div>
                </div>
                <div v-if="showkurs.fobipunkte" class="fobipkt has_icon">
                  <span class="icon_infront" uk-icon="star" />{{ showkurs.fobipunkte }}
                  Fortbildungspunkte
                </div>
                <div v-if="showkurs.gebza" class="kosten has_icon">
                  <span class="icon_infront" uk-icon="credit-card" />
                  <div>
                    <div v-if="Number(showkurs.gebza) >= 0" class="geb_zah">
                      Zahnärztinnen / Zahnärzte: {{ showkurs.gebza }} €
                    </div>
                    <div v-if="Number(showkurs.gebass) >= 0" class="geb_zfa">
                      Assistentinnen / Assistenten: {{ showkurs.gebass }} €
                    </div>
                    <div
                      v-if="
                        (Number(showkurs.gebzmf) >= 0 && isInGruppe(1)) ||
                        (Number(showkurs.gebzmf) >= 0 && isInGruppe(2)) ||
                        (Number(showkurs.gebzmf) >= 0 && isInGruppe(3))
                      "
                      class="geb_zfa"
                    >
                      ZFA: {{ showkurs.gebzmf }} €
                    </div>
                    <div
                      v-if="
                        (Number(showkurs.gebzah) >= 0 && isInGruppe(4)) ||
                        (Number(showkurs.gebzah) >= 0 && isInGruppe(5))
                      "
                      class="geb_zfa"
                    >
                      ZFA: {{ showkurs.gebzah }} €
                    </div>
                    <div v-if="Number(showkurs.gebsonst) >= 0" class="geb_zfa">
                      Kurspreis: {{ showkurs.gebsonst }} €
                    </div>
                  </div>
                </div>

                <a
                  v-if="showkurs.ampelstatus == 0"
                  target="_blank"
                  @click="openBuchenURL(showkurs)"
                >
                  <div class="btn_buch ampel_gruen">Direkt Buchen</div>
                </a>
                <a
                  v-if="showkurs.ampelstatus == 1"
                  target="_blank"
                  @click="openBuchenURL(showkurs)"
                >
                  <div class="btn_buch ampel_gelb">Restplätze</div>
                </a>
                <a
                  v-if="showkurs.ampelstatus == 2"
                  target="_blank"
                  @click="openBuchenURL(showkurs)"
                >
                  <div class="btn_buch ampel_rot">Voll/Warteliste</div>
                </a>
              </div>
            </div>
          </div>
          <div class="dozent">
            <div class="shadowwrap">
              <div class="sidebar_title dozent_header">Dozent</div>
              <div v-for="(dozent, dIndex) of showkurs.dozenten" :key="dIndex" class="innerwrap">
                <div v-if="dozent.images.length > 0" class="bild">
                  <img :src="dozent.images[0].identifier" />
                </div>
                <div v-else class="bild">
                  <img src="../assets/avatar.png" />
                </div>
                <div class="info">
                  <div class="name">
                    {{ dozent.akadtitel }} {{ dozent.vorname }} {{ dozent.nachname }}
                    {{ dozent.suffix }}
                  </div>
                  <div class="fachinfo" v-html="dozent.dozenttext" />
                </div>
                <!-- <div class="btn_details grau">Details</div> -->
              </div>
            </div>
          </div>
        </aside>
      </div>
      <div v-if="showkurs" id="khi_liste" class="uk-container">
        <div class="uk-grid">
          <kurslistitem
            v-for="kurs in kurse"
            v-show="sameGroup(kurs)"
            :key="kurs.interneid"
            :kurs="kurs"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import kurslistitem from "./kurslistitem.vue";

export default {
  name: "KursDetails",
  components: {
    kurslistitem,
  },
  data() {
    return {
      showkurs: null,
    };
  },
  computed: {
    ...mapGetters(["kurse", "buchungBaseURL1", "buchungBaseURL2"]),
  },

  watch: {
    $route(to, from) {
      console.log(to, from);
      const kursNeu = _.find(this.kurse, (o) => o.interneid === to.params.kursnummer);
      this.showkurs = kursNeu;
      window.scrollTo(0, 0);
    },
  },
  created() {
    console.log("Kurs.vue created");
    this.kursnummer = this.$route.params.kursnummer;

    if (this.kurse.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const kurs of this.kurse) {
        if (kurs.interneid === this.kursnummer) {
          this.showkurs = kurs;
        }
      }
    } else {
      console.log("we need a new kurs...");
      axios
        .get(`/api/kurse/single/${this.kursnummer}/`)
        .then((response) => {
          console.log(response);
          // eslint-disable-next-line prefer-destructuring
          this.showkurs = response.data[0];
        })
        .catch((error) => {
          console.log("error on kurs api:");
          console.log(error);
        });
    }

    console.log("this.showkurs: ", this.showkurs);
  },
  methods: {
    getDateString(tstamp) {
      console.log(tstamp);
      if (tstamp > 0) {
        const dateObj = new Date(tstamp * 1000);
        return `${this.appendZeroIfNeeded(dateObj.getDate())}.${this.appendZeroIfNeeded(
          dateObj.getMonth() + 1
        )}.${dateObj.getFullYear()}`;
      }
      return "-";
    },
    getTimeString(tstamp) {
      if (tstamp > 0) {
        const dateObj = new Date(tstamp * 1000);
        return `${dateObj.getHours()}:${dateObj.getMinutes()}`;
      }
      return "-";
    },
    appendZeroIfNeeded(integerDate) {
      if (integerDate < 10) {
        return `0${integerDate}`;
      }
      return integerDate;
    },
    openBuchenURL(kurs) {
      if (kurs.interneid === "25694") {
        window.open(
          "https://www.zahnaerztekammernordrhein.de/bereich/praxisteam/aufstiegsfortbildung-obf-fzp/lehrgang-zur-zum-fzp/",
          "_blank"
        );
      } else if (kurs.interneid === "25588") {
        window.open(
          "https://www.zahnaerztekammernordrhein.de/bereich/praxisteam/aufstiegsfortbildung-obf-fzp/offene-baustein-fortbildung-obf/",
          "_blank"
        );
      } else if (kurs.ingruppe_obf === 1) {
        // https://portal.zaek-nr.de/kursinteresse/<ARTIKEL_NR>
        window.open(this.buchungBaseURL2 + kurs.interneid, "_blank");
      } else {
        // https://portal.zaek-nr.de/kursanmeldung/<ARTIKEL_NR>
        window.open(this.buchungBaseURL1 + kurs.interneid, "_blank");
      }
    },
    sameGroup(target) {
      // console.log('target.gruppen', target);
      //  console.log('this.showkurs.gruppen', this.showkurs.gruppen);
      // console.log('this.showkurs.kurspaket', this.showkurs.kurspaket);
      const kursrel = this.showkurs.kurspaket;
      // console.log(kursrel);
      // console.log('this.showkurs.kurspaket', this.showkurs.kurspaket);
      if (target.kurspaket === kursrel && target.kurspaket !== "") {
        return this.showkurs.interneid !== target.interneid;
      }
      return null;

      // console.log('result', result);
    },
    isInGruppe(gruppeID) {
      return this.showkurs.gruppen.indexOf(gruppeID) >= 0;
    },
  },
};
</script>

<style scoped></style>
